import { isCancel } from 'axios';

export class OperationAbortedError extends Error {
  constructor(
    public reason: string,
    public error?: unknown,
  ) {
    super();
  }
}

export function throwApiError(e: unknown): never {
  if (e instanceof OperationAbortedError) {
    throw e;
  }

  if (isCancel(e)) {
    throw new OperationAbortedError(e.message ?? '', e);
  }

  if (e instanceof Error) {
    throw e;
  }

  throw new Error('Unknown error');
}
